import { render, staticRenderFns } from "./Decider.vue?vue&type=template&id=cc3f1774&"
import script from "./Decider.vue?vue&type=script&lang=js&"
export * from "./Decider.vue?vue&type=script&lang=js&"
import style0 from "./Decider.vue?vue&type=style&index=0&id=cc3f1774&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports